/* eslint-disable camelcase */
import moment from "moment";
import constants from "../../core/constants";
import isFinite from "lodash/fp/isFinite";
class ReservationPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    const format = (data) => {
      data.scheduleTime = moment()
        .startOf("day")
        .add(data.schedule.time, "ms")
        .format(constants.timeFormat);
      data.ride_price = isFinite(data.ride_price)
        ? `${data.ride_price / constants.currencyBy} ${data.route.currency}`
        : "N/A";

      data.supply_cost = isFinite(data.supply_cost)
        ? `${data.supply_cost / constants.currencyBy} ${data.route.currency}`
        : "Captain Plan";

      const districts = data.route.name.split("-");
      if (districts.length === 2) data.districts = districts;
      return data;
    };
    return format(data);
  }
}

export default ReservationPageTransform;



// WEBPACK FOOTER //
// ./src/pages/reservation/reservation.transforms.js